import { ExtendedAttribute } from '../models/extended-attribute';

export class AddExtendedAttributes {
    static readonly type = '[ExtendedAttribute] AddExtendedAttributes';

    constructor(public payload: ExtendedAttribute[]) {}
}
